const TYPE = 'ps.AisleSession'

function create() {
  return {
    type : TYPE
  }
}

export default {
  create
}
